
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ExpertiseSection from './components/ExpertiseSection';
import InnovationSection from './components/InnovationSection';
import StatsSection from './components/StatsSection';
import CommitmentSection from './components/CommitmentSection';
import CTASection from './components/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ExpertiseSection />
        <InnovationSection />
        <StatsSection />
        <CommitmentSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
